// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"553995bd","436":"676763c4","453":"f394a27d","501":"24eea38f","606":"bc84f383","925":"58c0ef02"}[chunkId] + ".chunk.js";
};